import { List } from 'immutable';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import CurrencySelect from 'ui-addon-i18n/components/CurrencySelect';
import FilterOperatorErrorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorErrorType';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceResolverAllType from 'reference-resolvers/schema/ReferenceResolverAllType';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FilterOperatorCurrencyCodeInput extends PureComponent {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleChange = evt => {
      const {
        multi,
        onChange
      } = this.props;
      if (multi) {
        onChange(syntheticEvent(List(evt.target.value)));
        return;
      }
      onChange(evt);
    };
    this.handleOptionsChange = options => {
      if (isResolved(options)) {
        this.setState({
          currencyCodes: List(options.map(record => record.id))
        });
      }
    };
    this.state = {
      currencyCodes: List()
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    this.configureResolver(this.props);
  }
  componentDidUpdate(nextProps) {
    if (nextProps.resolver !== this.props.resolver) {
      if (this.referenceAtom) {
        unwatch(this.referenceAtom, this.handleOptionsChange);
      }
      this.configureResolver(nextProps);
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleOptionsChange);
    }
  }
  configureResolver(props) {
    const {
      resolver,
      value
    } = props;
    if (resolver && typeof resolver.all !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver for Currency Code Input does not have 'all' function`));
    }
    if (value) {
      this.referenceAtom = resolver.all();
      watch(this.referenceAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceAtom));
    }
  }
  getValue() {
    const {
      multi,
      value
    } = this.props;
    if (multi) {
      return value ? value.toArray() : [];
    }
    return value;
  }
  render() {
    const {
      currencyCodes
    } = this.state;
    const {
      error,
      inputUse,
      multi
    } = this.props;
    const isError = error.get('error');
    const errorMessage = error.get('message');
    return /*#__PURE__*/_jsx(UIFormControl, {
      error: isError,
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(CurrencySelect, {
        currenciesFilter: currency => currencyCodes.includes(currency.value),
        currencyStyle: "long",
        multi: multi,
        onChange: this.handleChange,
        use: inputUse,
        value: this.getValue()
      })
    });
  }
}
FilterOperatorCurrencyCodeInput.propTypes = {
  error: FilterOperatorErrorType.isRequired,
  inputUse: PropTypes.oneOf(['on-dark']),
  multi: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  resolver: ReferenceResolverAllType.isRequired,
  value: PropTypes.string
};